export default {"src":"/_next/static/image/public/images/ic_big_add_members_warning.f104e0ee0e66525ae685ddbbca97637f.svg","height":160,"width":152};